export const roleHeadCells = {
    name: {
        id: 'name',
        label: "Role Name",
        showInView: true
    },
    id: {
        id: 'id',
        hidden: true,
        showInView: false
    }
}

export const offerListHeadCells = {
    id: {
        id: 'id',
        hidden: true,
        showInView: false
    },
    codeToShow: {
        id: 'codeToShow',
        label: "Code",
        showInView: true
    },
    claimed_at: {
        id: 'claimed_at',
        label: "Claimed At",
        showInView: true,
        type: 'date'
    },
    action: {
        id: 'action',
        label: "Action",
        showInView: true,
        showComponent: true
    },
}

export const planHeadCells = {
    id: {
        id: 'id',
        hidden: true,
        showInView: false
    },
    name: {
        id: 'name',
        label: "Offer Name",
        showInView: true
    },
    duration: {
        id: 'duration',
        label: "Offer Duration (in days)",
        showInView: true
    },
    identifier: {
        id: 'identifier',
        label: "Offer Identifier",
        showInView: true
    },
    unit: {
        id: 'unit',
        label: "Offer Unit",
        showInView: true
    },
    planAmount: {
        id: 'price',
        label: "Offer Amount",
        showInView: true
    },
    visibility: {
        id: 'visibility',
        label: "Visibility",
        showInView: true
    },
    uploadExcel: {
        id: 'uploadExcel',
        label: "Offer CSV File",
        showInView: true,
        showComponent: true
    },
}

export const usersHeadCells = {
    fName: {
        id: 'fName',
        label: "First Name",
    },
    lName: {
        id: 'lName',
        label: "Last Name",
    },
    email: {
        id: 'email',
        label: "Email",
    },
    mobile: {
        id: 'mobile',
        label: "Contact No.",
    },
    id: {
        id: 'id',
        hidden: true,
    }
}

export const totalOfferClaimHeadcells = {
    name: {
        id: 'name',
        label: "Offer Name",
        showInView: true
    },
    totalClaimed: {
        id: 'totalClaimed',
        label: "Total Claimed",
        showInView: true
    },
    brandName: {
        id: 'brandName',
        label: 'Brand Name',
        showInView: true
    }
}

export const bannerHeadCells = {
    id: {
        id: 'id',
        hidden: true,
        showInView: false
    },
    name: {
        id: 'name',
        label: "Banner Name",
        showInView: true
    },
    priority: {
        id: 'priority',
        label: "Priority",
        showInView: true
    },
}

export const mailTemplateHeadCells = {
    id: {
        id: 'id',
        hidden: true,
        showInView: false
    },
    email_template_name: {
        id: 'email_template_name',
        label: 'Email Template Name',
        showInView: true
    },
    from_email: {
        id: 'from_email',
        label: 'From Email',
        showInView: true
    },
    sms_template_id: {
        id: 'sms_template_id',
        label: 'SMS Template ID',
        showInView: true
    },
    offer_identifier: {
        id: 'offer_identifier',
        label: 'Offer Identifier',
        showInView: true
    },
    created_at: {
        id: 'created_at',
        label: 'Created At',
        showInView: true,
        type: 'date'
    },
}